var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorIconEating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eating"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2771 11.3746H14.4583C14.5729 11.3746 14.6667 11.4683 14.6667 11.5829C14.6667 11.6996 14.5729 11.7912 14.4583 11.7912H14.1854C14.1562 11.8058 14.125 11.8141 14.0917 11.8141H1.9125C1.87917 11.8141 1.84792 11.8058 1.81875 11.7912H1.54167C1.42708 11.7912 1.33333 11.6996 1.33333 11.5829C1.33333 11.4683 1.42708 11.3746 1.54167 11.3746H1.72292C1.85833 9.8308 2.33333 8.38288 3.10417 7.17872C3.14167 7.1183 3.20833 7.08288 3.27917 7.08288H12.7208C12.7557 7.08265 12.7901 7.09133 12.8208 7.1081C12.8514 7.12487 12.8772 7.14918 12.8958 7.17872C13.6646 8.38288 14.1417 9.82872 14.2771 11.3746Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 6.5721H4.33327V6.54881C4.33327 5.76936 5.09506 5.13512 6.03127 5.13512C6.10202 5.13512 6.17112 5.13922 6.24187 5.14607C6.51994 4.6721 7.09252 4.3721 7.7375 4.3721C8.42032 4.3721 9.0291 4.72005 9.28084 5.23648C9.48157 5.16936 9.69876 5.13512 9.91759 5.13512C10.8571 5.13512 11.6337 5.76388 11.6633 6.54196C11.665 6.55155 11.6666 6.56114 11.6666 6.5721Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorIconEating);
export default __webpack_public_path__ + "static/media/behavior-icon-eating.a9811dff134fd9697be33a8b2c21013a.svg";
export { ForwardRef as ReactComponent };